<template>
    <v-container class="mx-auto mx-lg-10 mx-md-10" fluid>
    <v-row class="mx-lg-10">
      <Breadcrumbs :items="breadcrumbs" />
    </v-row>
    <v-row align="start" class="px-md-16 px-sm-0 px-xs-0">
      <v-col cols="12" md="6" class="mt-10 text-start" >
        <!-- class="mr-16 mt-10 text-start" -->
        <InfoRowClickable
          :colorAccent="'fontGrey'"
          :fieldLabel="'החבילה שלי:'"
          :fieldValue="
            user.base_package.package
              ? user.base_package.package.name.EN
              : ' אין חבילה'
          "
          :method="'displayPackage'"
          :needsGap="true"
          @displayPackage="displayMainPackage = !displayMainPackage"
          class="pb-3"
          />
          <!-- :columnView="$vuetify.breakpoint.smAndDown ? true : false" -->
        <!-- if loading -->
        <v-col v-if="loading" cols="12" md="6" class="mr-lg-16 mr-md-16">
          <div class="text-center pa-10">
            <v-progress-circular
              indeterminate
              color="secondary"
              :size="200"
            ></v-progress-circular>
          </div>
        </v-col>
        <UserPackage v-if="!displayAllSubscriptions && !loading" />
        <v-row v-if="!displayAllSubscriptions && !loading">
          <v-col cols="12" md="6" class="px-0">
            <v-btn
              v-if="user.base_package.package.package_id !== 179"
              @click="purchaseProcedure"
              text
              plain
              class="text-decoration-underline fontDarkGrey--text text-h6"
            >
              החלפת חבילה ל
              <span class="fontGrey--text text-h6"> Prime basic </span>
            </v-btn>
            <p
              v-if="user.base_package.package.package_id !== 179"
              class="secondary--text pr-5 mt-2"
              :class="displayAllSubscriptions ? 'text-caption' : ' text-h6'"
            >
              כרוך בתשלום חד פעמי של 19.8 ש״ח
            </p>
          </v-col>
          <v-col cols="12" md="6" >
            <v-btn
              :to="`/user/${$route.params.id}/roaming/subscriptions`"
              link
              text
              plain
              class="text-decoration-underline fontDarkGrey--text text-h6"
            >
              לחבילות חו״ל לחץ כאן
              
            </v-btn>
          </v-col>
        </v-row>
        <ConfirmPopup
          v-model="displayAlert"
          :label="label"
          :message="message"
          @finish="handleSave"
          :otpConfirm="true"
          @otpConfirmed="handleSave"
          />
          <!-- @otpFailed="handleFailedOtp" -->
        <UserSubscriptions
          v-if="displayAllSubscriptions"
          @removeSubscription="handleRemoveSubscription"
        />
        <!-- seoarate to component ! check functionality -->
        <v-row v-if="displayAllowed">
          <v-col class="" cols="5">
            <v-select
              :items="allowedServices"
              v-model="basePackage"
              item-text="name.EN"
              item-value="id"
              outlined
              label="בחר מנוי"
            />
          </v-col>
        </v-row>
        <v-row justify="start" v-if="displayAllowed">
          <v-col cols="3">
            <v-btn
              @click="saveMainService"
              color="success"
              outlined
              x-large
              plain
              text
              class="text-h5 font-weight-bold"
            >
              שמור
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn
              @click="displayAllowed = !displayAllowed"
              color="error"
              outlined
              x-large
              plain
              text
              class="text-h5 font-weight-bold"
            >
              ביטול
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="1"></v-col> -->
      <!-- buttons -->
      <v-col cols="12" md="4">
        <ButtonsGroup :items="userOptions" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import isEqual from "lodash/isEqual";
import forEach from "lodash/forEach";
import fetchSubscriptions from "@/mixins/fetchSubscriptions.js";
import fetchUsers from "@/mixins/fetchUsers.js";
import subscriptions from "@/mixins/subscriptions.js";
import fetchUser from "@/mixins/fetchUser.js";
import { mapState, mapActions } from "vuex";
import Breadcrumbs from "@/components/CommonComponents/Selects/Breadcrumbs";
import InfoRowClickable from "@/components/CommonComponents/InfoRowClickable";

export default {
  name: "UserSubscriptionsManager",
  mixins: [fetchSubscriptions, fetchUsers, fetchUser, subscriptions],
  components: {
    InfoRowClickable,
    Breadcrumbs,
    ButtonsGroup: () => import('@/components/CommonComponents/Selects/ButtonsGroup'),
    UserPackage: () => import("@/components/User/UserPackage"),
    UserSubscriptions: () =>
      import("@/components/User/Subscriptions/UserSubscriptions"),
    ConfirmPopup: () =>
      import("@/components/CommonComponents/Dialogs/ConfirmPopup"),
  },
  data() {
    return {
      userSubscriptions: null,
      displayMainPackage: false,
      selectedMainService: null, // ?
      displayAllSubscriptions: false,
      isAbroad: false,
      displayAllowed: false,
      displayItems: null, //for endpoints
      loading: false,
      displayAlert: false,
      message: "",
      label: "",
      otp: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
    }),
    breadcrumbs() {
      return this.accountOwner
        ? [
            {
              text: "חזרה לעמוד ראשי",
              link: true,
              exact: true,
              disabled: false,
              to: {
                name: "profile",
                params: {
                  id: this.account.domain_id,
                },
              },
            },
            {
              text: "ניהול מנויים",
              link: true,
              exact: true,
              disabled: false,
              to: {
                name: "users",
              },
            },

            {
              text: `מנוי: ${this.user.profile.name}`, // 'מנוי',
              disabled: false,
              link: true,
              exact: true,
              to: {
                name: "user-profile",
                params: {
                  id: this.user.domain_user_id,
                },
              },
            },
            {
              text: "חבילות",
              disabled: true,
            },
          ]
        : [
            {
              text: `מנוי: ${this.user.profile.name}`, // 'מנוי',
              disabled: false,
              link: true,
              exact: true,
              to: {
                name: "user-profile",
                params: {
                  id: this.user.domain_user_id,
                },
              },
            },
            {
              text: "חבילות",
              disabled: true,
            },
          ];
    },
    userOptions() {
      return [
        {
          label: this.displayAllSubscriptions ? "החבילה שלי" : "שירותים נוספים", // "$vuetify.user.userOptionButtons.subscriptions", //"חבילות",
          icon: "mdi-folder-star-multiple-outline",
          link: `/user/${this.$route.params.id}/subscriptions`,
        },
        {
          label: "$vuetify.user.userOptionButtons.numbers", //"מספרים",
          icon: "mdi-account-box-multiple",
          link: `/user/${this.$route.params.id}/dids`,
        },
        {
          label: "$vuetify.accounts.pageTexts.options.abroad",
          icon: "icon-globe",
          link: `/user/${this.$route.params.id}/roaming/subscriptions`,
        },
        {
          label: "$vuetify.user.userOptionButtons.devices", //"מכשירים",
          icon: "mdi-devices",
          link: `/user/${this.$route.params.id}/device`,
        },
      ];
    },
    basePackage: {
      get() {
        return this.user.profile.base_package;
      },
      set(val) {
        this.selectedMainService = val;
      },
    },
  },
  mounted() {
    this.user;
    this.fetchUserSubscriptions();
    this.fetchUserEndpoints();
  },

  methods: {
    ...mapActions(["setUserProfile"]),
    handleSave() {
    
      this.displayAlert = false;
      this.saveMainService()
    },
    purchaseProcedure() {
      this.message = "שלח הודעה לאישור מנהל החשבון";
      this.label = "שירות בתשלום ";
      this.displayAlert = !this.displayAlert;
    },
    handleSelectedLink(index) {
      switch (index) {
        case 0:
          if (isEqual(this.$route.path, this.userOptions[index].link))
            this.displayAllSubscriptions = !this.displayAllSubscriptions;
          else this.$router.push(this.userOptions[index].link);
          break;
        default:
          this.displayAllSubscriptions = false;
          this.$router.push(this.userOptions[index].link);
          break;
      }
      return;
    },
    async saveMainService() {
      // console.log(' saveMainService  this.displayItems', this.displayItems[0].endpoint_id);
      const appAction = false;
      const functionName = "prov_update_mobile_subscription"; // "get_user_subscriptions";
      const reqBody = {
        fake: false,
        endpoint_id: this.displayItems[0].endpoint_id,
        service_id: 179,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      // console.log('saved... ', data);
      if (data.error_code === 200) {
        const user = await this.getUser(this.user);
        // console.log('user : ', user);
        this.$store.dispatch("setUserProfile", user);
        this.displayAllowed = false;
      }
    },

    async handleRemoveSubscription(subscriptionID) {
      this.loaded = false;
      this.loading = true;
      this.displayAllSubscriptions = false;
      const appAction = false;
      const functionName = "end_subscription_by_id";
      let item = this.findSubscriptionId(subscriptionID);
      const reqBody = {
        subscription_id: item,
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        const user = await this.getUser(this.user);
        this.$store.dispatch("setUserProfile", user);
        await this.fetchUserSubscriptions();
        this.loaded = true;
        this.loading = false;
        this.displayAllSubscriptions = true;
      }
    },
    findSubscriptionId(subscription) {
      let id = subscription.service_id;
      let subscriptionID;
      forEach(this.user.active_subscriptions, (el) => {
        if (el.package_id === id) return (subscriptionID = el);
      });
      return subscriptionID.id;
    },
  },
};
</script>
